<template>
  <div class="shop">
    <div class="title_box">
      <h2 class="title_left">{{items.title}}</h2>
      <router-link class="title_right" tag="span" to="/activity?come=wall">更多</router-link>
    </div>
    <!-- 一行3个 -->
    <!-- <ul class="shop_list" v-if="items.listStyle == 2">
      <router-link
        tag="li"
        :to="'/mall/goodsDetail/'+item.id"
        class="list_item"
        v-for="(item,index) in newList"
        :key="index"
      >
        <img :src="item.logo?item.logo:require(`../../../assets/images/img_company_wall.jpg`)" alt />
        <p>{{item.companyName}}</p>
      </router-link>
    </ul> -->
    <!-- 滚动8个-->
    <div class="scroll" ref="gun" v-if="items.listStyle == 1">
      <ul ref="nav" class="shop_list shop_list_scroll">
        <router-link
          ref="personTab"
          tag="li"
          :to="'/companyDetail/'+item.companyId"
          class="list_item list_item_scroll"
          v-for="(item,index) in newList"
          :key="index"
        >
          <div class="img_box">
            <img :src="item.logo?item.logo:require(`../../../assets/images/img_company_wall.jpg`)"/>
          </div>
          <p class="list_item_p">{{item.companyName}}</p>
          <p class="list_item_p list_item_address">{{item.address}}</p>
        </router-link>
      </ul>
    </div>
    <!-- 一行2个 -->
    <ul class="shop_list" v-else-if="items.listStyle == 0">
      <router-link
        tag="li"
        :to="'/companyDetail/'+item.companyId"
        class="list_item list_item_two"
        v-for="(item,index) in newList"
        :key="index"
      >
        <div class="img_box">
            <img :src="item.logo?item.logo:require(`../../../assets/images/img_company_wall.jpg`)"/>
          </div>
        <p class="list_item_p">{{item.companyName}}</p>
          <p class="list_item_p list_item_address">{{item.address}}</p>
      </router-link>
    </ul>
  </div>
</template>

<script>
import BScroll from "better-scroll";
export default {
  name: "indexActivity",
  props: {
    list: Array,
    items: Object
  },
  data() {
    return {};
  },
  computed: {
    newList() {
      let newList = this.list;
      if (this.items.listStyle === 1) {
        return newList.slice(0, 8);
      } else if (this.items.listStyle === 2) {
        return newList.slice(0, 6);
      } else if (this.items.listStyle === 0) {
        return newList.slice(0, 4);
      } else {
        return [];
      }
    }
  },
  created() {
    if (this.items.listStyle == 2) {
      setTimeout(() => {
        this.tabScroll();
      }, 2000);
    }
  },
  methods: {
    tabScroll() {
      if (!this.scroll) {
        this.$refs.nav.style.width =
          this.$refs.personTab[0].$el.clientWidth *
            this.$refs.personTab.length +
          "px";
        this.scroll = new BScroll(this.$refs.gun, {
          startX: 0,
          click: true,
          scrollX: true,
          // 忽略竖直方向的滚动
          scrollY: false,
          eventPassthrough: "vertical"
        });
      } else {
        this.scroll.refresh();
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.shop {
  padding: 0 20px 30px;
  .title_box {
    .flex();
    justify-content: space-between;
    align-items: center;
    height: 1rem;
    .title_left {
      .flex();
      flex-direction: row;
      font-size: 0.36rem;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
    .title_right {
      font-size: 0.26rem;
      color: #666;
    }
  }
}
.shop_list {
  .flex();
  justify-content: space-between;
  .list_item {
    .flex();
    flex-direction: column;
    width: 260px;
    .border();
    margin-right: 20px;
    background-color: #ffffff;
    overflow: hidden;
    box-sizing:border-box;
    margin-bottom: 20px;
    box-shadow:0px 4px 12px 0px rgba(0,0,0,0.04);
    .img_box{
      display:flex;
      flex-direction:row;
      justify-content:center;
      align-items: center;
      img {
        display: block;
        width: 160px;
        height: 160px;
        padding:40px 0 28px;
        object-fit: contain;
        margin:0 auto;
      }
    }
    p {
      margin-top: 20px;
      margin-left: 20px;
      width: 240px;
      .fontSize(14px);
      font-weight: bold;
      color: @color3;
      line-height: 40px;
      text-align: left;
      .textOver(240px);
    }
  }
  .list_item_two {
    width: 344px;
    height:344px;
    .border();
    .flex();
    flex-direction:column;
    margin:0 0 20px 0;
    text-align: center;
    align-items: center;
    .img_box{
      width: 100%;
      height: 228px;
      display:flex;
      flex-direction:row;
      justify-content:center;
      align-items: center;
      border:0;
      img {
        display: block;
        width: 160px;
        height: 160px;
        padding:40px 0 28px;
        margin:0 auto;
      }
    }
    p {
      margin:0;
      text-align:center;
      .textOver(300px);
    }
    .list_item_address{
      font-size:24px;
      color:rgba(153,153,153,1);
      line-height:34px;
      margin:8px 20px 0 20px;
      font-weight:normal;
    }
  }
}
.shop_list_scroll {
  flex-wrap: nowrap;
  justify-content: flex-start;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  margin-bottom:0;
  .list_item {
    flex-shrink: 0;
    width: 280px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    overflow: hidden;
    margin-right: 20px;
    .border();
    box-sizing:border-box;
    box-shadow:0px 4px 12px 0px rgba(0,0,0,0.04);
    .img_box{
      display:flex;
      flex-direction:row;
      justify-content:center;
      align-items: center;
      img {
        display: block;
        width: 160px;
        height: 160px;
        padding:40px 0 28px;
        margin:0 auto;
      }
    }
    .list_item_p {
      margin:0 20px;
      .fontSize(12px);
      font-weight: bold;
      color: @color3;
      line-height: 34px;
      text-align: left;
      width:240px;
      .textOver(240px);
    }
    .list_item_address{
      font-size:24px;
      color:rgba(153,153,153,1);
      line-height:34px;
      margin:8px 20px 34px 20px;
      font-weight:normal;
    }
  }
}
</style>
